enum FormSubsectionId {
  GOV_INTEGRATION_FINANCEMENT = 'gov-integration-financement',
  PRES_TERRITOIRES_PROTEGES = 'pres-territoires-proteges',
  PRES_ECOSYSTEMES_ESPECES = 'pres-ecosystemes-especes',
  PRES_ESPECES_EXOTIQUES = 'pres-especes-exotiques',
  MULTI_SANTE_LOISIRS = 'multi-sante-loisirs',
  MULTI_SERVICES_ECOSYSTEMIQUES = 'multi-services-ecosystemiques',
  MULTI_ENGAGEMENT_COLLECTIF = 'multi-engagement-collectif',
}

export default FormSubsectionId;
